/* eslint-disable react/react-in-jsx-scope */
import { useTranslation } from "react-i18next";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import usePostData from "@/hooks/usePostData";

import 'react-loading-skeleton/dist/skeleton.css';
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Mail, Check } from "lucide-react";
import { langs } from "@/constants/constants";
import { useParams } from 'react-router-dom';

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { z } from "zod";
import PasswordStrengthCheck from "../../dashboard/components/subcontractor/PasswordStrengthCheck";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Eye, EyeOff, Save } from "lucide-react";
import { toast } from "@/components/ui/use-toast";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { useNavigate } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useHidePostActions } from "@/auth/hooks/useHidePostActions";


const SubscriptionPartner = () => {
  const { t } = useTranslation("general");
  const { postData } = usePostData();
  const hidePostActions = useHidePostActions();
  const { i18n } = useTranslation();
  const [counter, setCounter] = useState(10);
  const [isRedirecting,setIsRedirecting] = useState(false); 
  const {metacode} =  useParams<{ metacode: string; }>();
  const [nomProgramme, setNomProgramme] = useState("");
  const [newLinkGenerated, setNewLinkGenerated] = useState("");
  const normalizedSearch = React.useMemo(() => {
    const rawSearch = window.location.search ?? "";
    const questionMarkCount = (rawSearch.match(/\?/g) ?? []).length;

    if (questionMarkCount <= 1) {
      return rawSearch;
    }

    const firstQuestionMarkIndex = rawSearch.indexOf("?");
    if (firstQuestionMarkIndex === -1) {
      return rawSearch;
    }

    const query = rawSearch.slice(firstQuestionMarkIndex + 1);
    const normalizedQuery = query.replace(/\?/g, "&");

    return `?${normalizedQuery}`;
  }, []);
  const params = new URLSearchParams(normalizedSearch);
  const tokenPermission = params.get("permission");
  const restriction = params.get("restriction");

  const navigate = useNavigate();
  const [loadingCheck, setLoadingCheck] = useState(true);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [linkError, setLinkError] = useState<string | null>(null);

    useEffect(() => {
        if (window.location.search !== normalizedSearch) {
           window.history.replaceState(null, "", `${window.location.pathname}${normalizedSearch}`);
        }
    }, [normalizedSearch]);

    useEffect(() => {
        const fetchData = async () => {
            setLinkError(null);
            try {
                const restrictionQuery = restriction ? `&restriction=${encodeURIComponent(restriction)}` : "";
                const response = await fetch(`${import.meta.env.VITE_API_ENDPOINT}/user-check?codeMeta=${metacode}${restrictionQuery}`);

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const json = await response.json();

                if (json.success) {
                    setFirstName(json.firstname);
                    setLastName(json.lastname);
                    setNomProgramme(json.programName);
                } else {
                    setLinkError(json.message ?? "Lien invalide");
                }
            } catch (err: any) {
                setLinkError(err.message || "Lien invalide");
                console.log(err.message || "Unknown error");
            } finally {
                setLoadingCheck(false);
            }
        };
        fetchData();
    }, [metacode, restriction]);

  useEffect(() => {
        const timer = setInterval(() => {
            if(isRedirecting === true) {
                setCounter((prevCounter) => prevCounter - 1);
            }
        }, 1000);

        // Quand le compteur atteint 0, redirection
        if (counter === 0 && isRedirecting === true) {
            // localStorage.setItem("code", "Regenerate2024!");
            window.location.href = "/login";
            // window.location.href = "/login-subcontractor/authentification";
        }
        // Nettoyer l'intervalle à chaque rendu ou démontage
        return () => clearInterval(timer);
    
  }, [counter, isRedirecting]);

    const [loadingSave, setLoadingSave] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    const [isPasswordOk, setIsPasswordOk] = useState(true);

    function getFormSchema(isEditMode: boolean, isPasswordOk: boolean) {
    const baseFields = {
        lastname: z.string().min(2, {
        message: t("Le nom de famille doit contenir au moins 2 caractères."),
        }),
        firstname: z.string().min(2, {
        message: t("Le prénom doit contenir au moins 2 caractères."),
        }),
        email: z.string().email({
        message: t("L'adresse e-mail n'est pas valide."),
        }),
    };

    const passwordField = z
        .string()
        .min(8, t("Le mot de passe doit comporter au moins 8 caractères."))
        .refine((val) => /[a-z]/.test(val), {
        message: t("Le mot de passe doit contenir au moins une lettre minuscule."),
        })
        .refine((val) => /[A-Z]/.test(val), {
        message: t("Le mot de passe doit contenir au moins une lettre majuscule."),
        })
        .refine((val) => /\d/.test(val), {
        message: t("Le mot de passe doit contenir au moins un chiffre."),
        })
        .refine((val) => /[!@#$%^&*(),.?":{}|<>]/.test(val), {
        message: t("Le mot de passe doit contenir au moins un caractère spécial."),
        });

    const confirmPasswordField = z
        .string()
        .min(8, {
        message: t("La confirmation du mot de passe doit contenir au moins 8 caractères."),
        })
        .regex(passwordRegex, {
        message: t(
            "La confirmation du mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre."
        ),
        });

    const shouldValidatePassword = !isEditMode || (isEditMode && !isPasswordOk);

    const schema = z.object({
        ...baseFields,
        ...(shouldValidatePassword
        ? {
            password: passwordField,
            confirmPassword: confirmPasswordField,
            }
        : {
            password: z.string().optional(),
            confirmPassword: z.string().optional(),
            }),
    });

    // Ajoute la validation que les deux mdp doivent correspondre
    return shouldValidatePassword
        ? schema.refine((data) => data.password === data.confirmPassword, {
            path: ["confirmPassword"],
            message: t("Les mots de passe ne correspondent pas."),
        })
        : schema;
    }
    
    
    const formSchema = getFormSchema(isPasswordOk);
    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        confirmPassword: ""
        },
    });

    const password = form.watch("password");

    const handleSave = async (data: z.infer<typeof formSchema>) => {
        
        setLoadingSave(true);
        
        const urlApi = `${import.meta.env.VITE_IP_API}/api/partner/subscription/${metacode}`;
    
        const res = await postData({
          url: urlApi,
          data: {
              firstname: data.firstname,
              lastname: data.lastname,
              addresseEmail: data.email,
              mdp: data.password,
              tokenPermission: tokenPermission
            },
        });
    
        if (res === null) {
            console.log("Inexistant email");
            toast({
                title: t("L'adresse email n'existe pas"),
                duration: 3000,
            });
            setLoadingSave(false);
            setIsRedirecting(false);
        }else if (res.success !== undefined && res.success) {
            setIsRedirecting(true);
            setNewLinkGenerated(res.newLink);
        }  else if(res.error) {

            setLoadingSave(false);
            setIsRedirecting(false);
            setCounter(10);

            if(res.message) {
                toast({
                    title: t(res.message),
                    duration: 3000,
                });
            } else {
                toast({
                    title: t("L'adresse email est déjà utilisé par un autre utilisateur"),
                    duration: 3000,
                });
            }
            
        } else if (res && res.message) {
            setLoadingSave(false);
            setIsRedirecting(false);
            setCounter(10);

            toast({
                title: t(res.message),
                duration: 3000,
            });
        } else {
            // If not successful, check for a specific message from the API
            if (res.message) {
                toast({
                title: t("L'adresse email n'existe pas"), // Use the message directly from the API response
                duration: 3000,
                });
            } else {
                // Fallback for generic errors
                toast({
                title: "Une erreur est survenue",
                duration: 3000,
                });
            }
            setLoadingSave(false);
            setIsRedirecting(false);

            setCounter(10);

        }
        
      };
      useEffect(() => {
            // Vérifie si toutes les règles sont respectées
            const isValid =
              password?.length >= 8 &&
              /[a-z]/.test(password) &&
              /[A-Z]/.test(password) &&
              /\d/.test(password) &&
              /[!@#$%^&*(),.?":{}|<>]/.test(password);
        
            setIsPasswordValid(isValid);
          }, [password]);
      
    
 

  return (
    <div className="container mb-8">
        <nav className="relative flex h-16 items-center border-b md:h-24">
            <ul className="flex w-full items-center">
                <li>
                    <Link to="https://verdeo.fr">
                    <img
                        src="/logo.svg"
                        alt="logo verdeo"
                        width={138}
                        className="w-24 md:w-[138px]"
                    />
                    </Link>
                </li>
                 <li className="ml-auto mr-4">
                    <DropdownMenu>
                    <DropdownMenuTrigger asChild className="cursor-pointer">
                        <div className="flex items-center">
                        {i18n === undefined ||
                        i18n === null ||
                        i18n.language === undefined ||
                        i18n.language === null
                            ? "FR"
                            : i18n.language.split("-")[0].toUpperCase()}
                        
                        <ChevronDown className="size-4 opacity-50" />
                        </div>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="min-w-[10px]">
                        <DropdownMenuGroup className="w-[50px]">
                        {langs.map((lang, key) => (
                            <DropdownMenuItem
                            className="cursor-pointer hover:bg-white focus:bg-white focus:text-black"
                            onClick={() => {
                                i18n.language !== lang && i18n.changeLanguage(lang);
                            }}
                            key={key}
                            >
                            {lang.toUpperCase()}
                            {/* <span className={"fi fi-"+(lang === "en" ? "gb" : lang)+(i18n.language === lang ? " opacity-70 cursor-not-allowed" : "")} style={{
                                        width: '45px',
                                        height: '25px',
                                        backgroundSize: 'contain',
                                    }}></span> */}
                            </DropdownMenuItem>
                        ))}
                        </DropdownMenuGroup>
                    </DropdownMenuContent>
                    </DropdownMenu>
                </li>
                <li className="mr-4 text-right">
                    <a
                    href="https://verdeo.fr/contact/"
                    className="group relative flex size-[42px] items-center justify-center rounded-full border border-foreground md:size-max md:border-0"
                    >
                    <span className="hidden text-xs md:block md:text-base">
                        {t("Contactez-nous")}!{" "}
                    </span>
                    <span className="absolute left-0 top-full hidden h-px w-0 bg-foreground transition-all group-hover:w-full md:block"></span>
                    <Mail className="block stroke-1 md:hidden" />
                    </a>
                </li>
            </ul>
        </nav>
        {loadingCheck == true ? (
            <UserCheckSkeleton/>
        ) : (
            <>
                {linkError && (
                    <div className="mx-auto mb-5 mt-8 flex flex-wrap lg:w-2/4">
                        <Card>
                            <CardHeader>
                                <CardTitle>{t("Lien invalide")}</CardTitle>
                                <CardDescription>{linkError}</CardDescription>
                            </CardHeader>
                        </Card>
                    </div>
                )}

                {!linkError && isRedirecting === false && (
                    <div className="mx-auto mb-5 mt-8 flex flex-wrap lg:w-2/4">
                        <Card>
                            <CardHeader>
                                <CardTitle>{t("créez votre compte")}</CardTitle>
                                <CardDescription>
                                    {
                                        "Le porteur de projet " + firstName+ " "+lastName + " vous a référencé sur Verdeo comme collaborateur de ses projets."
                                    }
                                </CardDescription>
                            </CardHeader>
                            <CardContent>
                                <Form {...form}>
                                    <form onSubmit={form.handleSubmit(handleSave)} className="space-y-8">
                                        <div className="flex flex-wrap gap-4">
                                            <div className="flex flex-wrap gap-4">
                                                {/* Email en pleine largeur */}
                                                <div className="w-full">
                                                <FormField
                                                    control={form.control}
                                                    name="email"
                                                    render={({ field }) => (
                                                    <FormItem>
                                                        <FormLabel>{t("Email")} *</FormLabel>
                                                        <FormControl>
                                                        <Input placeholder={t("Email")} {...field} type="email" />
                                                        </FormControl>
                                                        <FormMessage />
                                                    </FormItem>
                                                    )}
                                                />
                                                </div>
                                                {/* Nom + Prénom */}
                                                <div className="flex w-full gap-4">
                                                    <div className="w-1/2">
                                                        <FormField
                                                        control={form.control}
                                                        name="lastname"
                                                        render={({ field }) => (
                                                            <FormItem>
                                                            <FormLabel>{t("Nom")} *</FormLabel>
                                                            <FormControl>
                                                                <Input placeholder={t("Nom")} {...field} />
                                                            </FormControl>
                                                            <FormMessage />
                                                            </FormItem>
                                                        )}
                                                        />
                                                    </div>
                                                    <div className="w-1/2">
                                                        <FormField
                                                        control={form.control}
                                                        name="firstname"
                                                        render={({ field }) => (
                                                            <FormItem>
                                                            <FormLabel>{t("Prénom")} *</FormLabel>
                                                            <FormControl>
                                                                <Input placeholder={t("Prénom")} {...field} />
                                                            </FormControl>
                                                            <FormMessage />
                                                            </FormItem>
                                                        )}
                                                        />
                                                    </div>
                                                </div>
                        
                                                
                                                <div className="flex w-full gap-4">
                                                    <div className="w-1/2">
                                                        <FormField
                                                        control={form.control}
                                                        name="password"
                                                        render={({ field }) => (
                                                            <FormItem>
                                                            <FormLabel>{t("Mot de passe")} *</FormLabel>
                                                            <FormControl>
                                                                <div className="relative">
                                                                <Input
                                                                    placeholder={t("Mot de passe")}
                                                                    {...field}
                                                                    type={showPassword ? "text" : "password"}
                                                                />
                                                                <button
                                                                    onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setShowPassword(!showPassword);
                                                                    }}
                                                                    className="absolute right-2 top-1/2 flex size-5 -translate-y-1/2 items-center justify-center"
                                                                >
                                                                    {!showPassword ? <EyeOff /> : <Eye />}
                                                                </button>
                                                                </div>
                                                            </FormControl>
                                                            <FormMessage />
                                                            {password && (
                                                                <PasswordStrengthCheck
                                                                password={password}
                                                                isPasswordValid={isPasswordValid}
                                                                className="mt-0"
                                                                />
                                                            )}
                                                            </FormItem>
                                                        )}
                                                        />
                                                    </div>            
                                                    <div className="w-1/2">
                                                        <FormField
                                                        control={form.control}
                                                        name="confirmPassword"
                                                        render={({ field }) => (
                                                            <FormItem>
                                                                <FormLabel>{t("Confirmation mot de passe")} *</FormLabel>
                                                                <FormControl>
                                                                    <div className="relative">
                                                                    <Input
                                                                        placeholder={t("Confirmation mot de passe")}
                                                                        {...field}
                                                                        type={showPasswordConfirm ? "text" : "password"}
                                                                    />
                                                                    <button
                                                                        onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setShowPasswordConfirm(!showPasswordConfirm);
                                                                        }}
                                                                        className="absolute right-2 top-1/2 flex size-5 -translate-y-1/2 items-center justify-center"
                                                                    >
                                                                        {!showPasswordConfirm ? <EyeOff /> : <Eye />}
                                                                    </button>
                                                                    </div>
                                                                </FormControl>
                                                                <FormMessage />
                                                            </FormItem>
                                                        )}
                                                        />
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </form>
                                </Form>
                                <br/>

                                {!hidePostActions && (
                                  loadingSave ? (
                                    <div className={"w-full items-center"}>
                                      <LoadingSpinner textChargement="Enregistrement en cours.."/>
                                    </div>
                                  ) : (
                                    <Button
                                      onClick={form.handleSubmit(handleSave)}
                                      type="button"
                                      disabled={loadingSave}
                                      className={"mt-4 w-full flex items-center gap-2"}
                                    >
                                      <Save size={18} />
                                      {t("S'inscrire")}
                                    </Button>
                                  )
                                )}
                            </CardContent>
                        </Card>
                    </div>
                )}
                
                {!linkError && isRedirecting === true && (
                    <div className="mx-auto mb-5 mt-8 flex flex-wrap lg:w-3/4">
                        <Card>
                            <CardHeader>
                                <CardTitle>
                                    <div className="w-full flex gap-2">
                                        {t("Inscription réussie")} 
                                        <Check size={42} color="green"/>
                                    </div>
                                </CardTitle>
                                <CardDescription>
                                    {t("Votre inscription a été réalisée")}
                                </CardDescription>
                            </CardHeader>
                                
                            <CardContent>
                                <p className="items-center">{t("Redirection dans")} <b>{counter}</b> {t("seconde")}{counter > 1 ? 's' : ''}...</p>
                            </CardContent>
                        </Card>
                    </div>
                )}
            </>
        )}
        
    </div>
  );
};

const UserCheckSkeleton = () => {
  return (
    <div className="p-4 border rounded-lg shadow-sm bg-white max-w-lg mx-auto mt-4">
      {/* Avatar skeleton */}
      <div className="flex justify-center mb-4">
        <Skeleton circle width={80} height={80} />
      </div>

      {/* Nom */}
      <div className="mb-2">
        <Skeleton height={20} width={`60%`} style={{ margin: '0 auto' }} />
      </div>

      {/* Email */}
      <div className="mb-2">
        <Skeleton height={16} width={`80%`} style={{ margin: '0 auto' }} />
      </div>

      {/* Autres infos */}
      <div className="mt-4 space-y-2">
        <Skeleton height={14} width={`90%`} />
        <Skeleton height={14} width={`85%`} />
        <Skeleton height={14} width={`80%`} />
      </div>

      {/* Bouton ou action */}
      <div className="mt-6">
        <Skeleton height={36} width={`100%`} borderRadius={8} />
      </div>
    </div>
  );
}

export default SubscriptionPartner;
